import { ProductLKType } from 'enums/product-lk-type';

export const productLkTypeNames: { [p: string]: string } = {
    [ProductLKType[ProductLKType.Sales]]: 'Sales',
    [ProductLKType[ProductLKType.PreSales]]: 'Pre Sales',
    [ProductLKType[ProductLKType.Technical]]: 'Technical',
    [ProductLKType[ProductLKType.KExpertClubCertified]]: 'K Expert Club Certified',
};
